//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: 'MdmBreadcrumb',
  props: {
    items: {
      type: Array,
      required: true
    }
  },
  computed: {
    itemListElement() {
      const items = this.items.slice();
      items.shift();
      return items.map((value, index) => ({
        '@type': 'ListItem',
        position: index + 1,
        item: {
          name: value.label,
          '@id': value.url
        }
      }));
    },

    structuredData() {
      return {
        '@context': 'http://schema.org',
        '@type': 'BreadcrumbList',
        itemListElement: this.itemListElement
      };
    }

  },

  head() {
    return {
      script: [{
        type: 'application/ld+json',
        innerHTML: JSON.stringify(this.structuredData),
        body: true
      }]
    };
  }

};